import { FormEvent, useEffect, useState } from "react";
import { Plus, Save } from "lucide-react";
import { request } from "./FunctionalApp";

async function api(path: string, init: RequestInit = {}) {
  const response = await request(path, init),
    body = await response.json().catch(() => ({}));
  if (!response.ok)
    throw new Error(
      String(body.error || "Unable to save").replaceAll("_", " "),
    );
  return body;
}

export function JobTypeSettings() {
  const [items, setItems] = useState<any[]>([]),
    [canManage, setCanManage] = useState(false),
    [message, setMessage] = useState("");
  const [draft, setDraft] = useState({
    name: "",
    appliesTo: "WORK_ORDER",
    contractor: false,
  });
  async function load() {
    try {
      const data = await api("/api/cmms/job-types");
      setItems(data.items);
      setCanManage(data.canManage);
    } catch (e: any) {
      setMessage(e.message);
    }
  }
  useEffect(() => {
    load();
  }, []);
  async function create(e: FormEvent) {
    e.preventDefault();
    try {
      await api("/api/cmms/job-types", {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify(draft),
      });
      setDraft({ name: "", appliesTo: "WORK_ORDER", contractor: false });
      setMessage("Job type added");
      await load();
    } catch (e: any) {
      setMessage(e.message);
    }
  }
  async function save(item: any) {
    try {
      await api(`/api/cmms/job-types/${item.id}`, {
        method: "PUT",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          name: item.name,
          appliesTo: item.applies_to,
          contractor: Boolean(item.contractor),
          active: Boolean(item.active),
        }),
      });
      setMessage("Job type saved");
      await load();
    } catch (e: any) {
      setMessage(e.message);
    }
  }
  if (!canManage && !items.length) return null;
  return (
    <section className="func-panel job-types">
      <div className="func-table-head">
        <div>
          <h2>Job types</h2>
          <p>
            Customise the classifications available for Helpdesk, reactive work
            and PPM schedules.
          </p>
        </div>
      </div>
      {message ? <p className="func-admin-note">{message}</p> : null}
      <div className="job-type-list">
        {items.map((item, index) => (
          <div key={item.id}>
            <input
              aria-label="Job type name"
              value={item.name}
              disabled={!canManage}
              onChange={(e) =>
                setItems(
                  items.map((x, i) =>
                    i === index ? { ...x, name: e.target.value } : x,
                  ),
                )
              }
            />
            <select
              value={item.applies_to}
              disabled={
                !canManage ||
                Number(item.work_order_count) + Number(item.plan_count) > 0
              }
              onChange={(e) =>
                setItems(
                  items.map((x, i) =>
                    i === index ? { ...x, applies_to: e.target.value } : x,
                  ),
                )
              }
            >
              <option value="HELPDESK">Helpdesk</option>
              <option value="WORK_ORDER">Work order</option>
              <option value="PPM">PPM schedule</option>
            </select>
            <label>
              <input
                type="checkbox"
                checked={Boolean(item.contractor)}
                disabled={!canManage}
                onChange={(e) =>
                  setItems(
                    items.map((x, i) =>
                      i === index ? { ...x, contractor: e.target.checked } : x,
                    ),
                  )
                }
              />{" "}
              Contractor
            </label>
            <label>
              <input
                type="checkbox"
                checked={Boolean(item.active)}
                disabled={!canManage}
                onChange={(e) =>
                  setItems(
                    items.map((x, i) =>
                      i === index ? { ...x, active: e.target.checked } : x,
                    ),
                  )
                }
              />{" "}
              Active
            </label>
            <small>
              {Number(item.work_order_count) + Number(item.plan_count)} linked
            </small>
            {canManage ? (
              <button className="secondary" onClick={() => save(item)}>
                <Save /> Save
              </button>
            ) : null}
          </div>
        ))}
      </div>
      {canManage ? (
        <form className="job-type-create" onSubmit={create}>
          <input
            required
            minLength={2}
            maxLength={100}
            placeholder="New job type name"
            value={draft.name}
            onChange={(e) => setDraft({ ...draft, name: e.target.value })}
          />
          <select
            value={draft.appliesTo}
            onChange={(e) => setDraft({ ...draft, appliesTo: e.target.value })}
          >
            <option value="HELPDESK">Helpdesk</option>
            <option value="WORK_ORDER">Work order</option>
            <option value="PPM">PPM schedule</option>
          </select>
          <label>
            <input
              type="checkbox"
              checked={draft.contractor}
              onChange={(e) =>
                setDraft({ ...draft, contractor: e.target.checked })
              }
            />{" "}
            Contractor
          </label>
          <button>
            <Plus /> Add job type
          </button>
        </form>
      ) : null}
    </section>
  );
}
